<template>
  <!--START TESTIMONIAL-->
  <section class="section" id="testi">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">O que dizem as boas línguas</h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >
            Mais de 1000 startups iniciadas com sucesso nos renderam algumas
            frases de tocar o coração s2.
          </p>
        </div>
      </div>
      <div class="row margin-t-50">
        <div class="col-lg-4">
          <div class="testimonial-box hover-effect margin-t-30">
            <img
              src="images/testimonials/user-2.jpg"
              alt=""
              class="img-fluid d-block img-thumbnail rounded-circle"
            />
            <div class="testimonial-decs">
              <p class="text-muted text-center mb-0">
                “Tenho certeza de que a Startandu tem o serviço ideal se você
                não sabe bem como começar a colocar em prática alguma ideia
                inovadora. Eles me coocaram nos trilhos e me mostraram
                exatamente onde precisava mirar para ter sucesso”
              </p>
            </div>
            <h5 class="text-center text-uppercase padding-t-15">
              Juan Nascimento - Chatlegal.io
              <span class="text-muted text-capitalize"
                ><br />Rio de Janeiro - RJ</span
              >
            </h5>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="testimonial-box hover-effect margin-t-30">
            <img
              src="images/testimonials/user-1.jpg"
              alt=""
              class="img-fluid d-block img-thumbnail rounded-circle"
            />
            <div class="testimonial-decs">
              <p class="text-muted text-center mb-0">
                “Não é apenas tecnologia, conhecimento, gestão, cumprimento de
                prazos e metas. Para iniciar uma startup de sucesso é preciso
                uma boa mentoria e a Startandu me ajudou a mudar completamente
                meu modelo de negócio para um modelo que hoje me rendeu a
                indepência que tanto queria.”
              </p>
            </div>
            <h5 class="text-center text-uppercase padding-t-15">
              Marianna Figueiredo - Connectify
              <span class="text-muted text-capitalize"
                ><br />Ribeirão Preto - SP</span
              >
            </h5>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="testimonial-box hover-effect margin-t-30">
            <img
              src="images/testimonials/user-3.jpg"
              alt=""
              class="img-fluid d-block img-thumbnail rounded-circle"
            />
            <div class="testimonial-decs">
              <p class="text-muted text-center mb-0">
                “Meu sonho sempre foi iniciar meu próprio negócio e sempre fui
                apaixonado por tecnologia, mas apenas a Startandu conseguiu me
                ajudar nesta jornada. Eu não conhecia nada a não ser programação
                e redes e eles me ajudaram com toda a parte burocrática na qual
                não tinha nem expertise e experiência.”
              </p>
            </div>
            <h5 class="text-center text-uppercase padding-t-15">
              Julianna Freitas - New Age IOT solutions
              <span class="text-muted text-capitalize"
                ><br />São Paulo - SP</span
              >
            </h5>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END TESTIMONIAL-->
</template>

<script>
"use strict";
export default {
  name: "Testimonial",
  props: {}
};
</script>
